module.exports = __webpack_public_path__ + "static/media/car11.c99cafb2.png";